<template>
    <li class="stuff-item">
        <img v-if="detail.status === AssetStatus.USED" src="../images/icon-checked.png" class="stuff-used">
        <div class="stuff-content">
            <img :src="detail.cover" :alt="detail.productName" class="stuff-img">
            <div v-if="detail.type === GoodsType.PROP" class="stuff-name">
                <span class="stuff-label">{{detail.productName}}</span>
                <span class="stuff-num">x{{ detail.goods.length }}</span>
            </div>
        </div>
        <button
            v-if="detail.type !== GoodsType.PROP"
            class="stuff-btn"
            :class="{ 'stuff-btn-disabled': disabled }"
            :disabled="disabled"
            @click="handleUse">
            {{ disabled ? '使用中' : '使用'}}
        </button>
    </li>
</template>

<script>
import { mapMutations } from 'vuex'
import { apiUseAsset } from '@/models/mall'
import { GoodsType, AssetStatus } from '@/constants/mall'

export default {
    name: "StuffItem",
    props: {
        detail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            GoodsType,
            AssetStatus,
        }
    },
    computed: {
        disabled() {
            return  this.detail.status === AssetStatus.USED
        }
    },
    methods: {
        ...mapMutations('goods', ['setUserImage']),
        async handleUse() {
            try {
                this.$lLoading.show()
                await apiUseAsset({
                    id: this.detail.id,
                    status: AssetStatus.USED,
                })
                // this.detail.status = AssetStatus.USED
                // if (this.detail.type === GoodsType.DRESS_UP) {
                //     this.setUserImage(this.detail.img)
                // }
                this.$emit('used', this.detail)
            } finally {
                this.$lLoading.hide()
            }
        }
    }
}
</script>

<style scoped>
.stuff-item {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.stuff-used {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
}
.stuff-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    background: #fff3d3;
    border-radius: 28px
}
.stuff-img {
    width: 152px;
    height: 168px;
    object-fit: cover;
    border-radius: 30px;
}
.stuff-name {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
}
.stuff-label {
    font-size: 20px;
    font-weight: bold;
    color: #6F6C68;
}
.stuff-num {
    margin-left: 8px;
    font-size: 24px;
    font-weight: bold;
    color: #8BB91C;
}
.stuff-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 163px;
    height: 49px;
    margin-top: 8px;
    background: #ffe952;
    border: 0;
    border-radius: 24px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ffbe31 inset; 
    color: #DD7146;
    font-size: 24px;
    font-weight: bold;
}
.stuff-btn-disabled {
    background: #fff3d3;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
    color: #B18F54;
}
</style>